export default __webpack_public_path__ + "static/media/cityEn.ef7e762d.png";